var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0562499 20.9111L2.53125 12.037H12.9938C13.275 12.037 13.5563 11.7648 13.5563 11.4926V10.4037C13.5563 10.1315 13.275 9.85931 12.9938 9.85931H2.53125L0.1125 1.14851C0.05625 1.03962 0 0.876296 0 0.712969C0 0.331871 0.39375 -0.0492269 0.84375 0.00521564C0.95625 0.00521564 1.0125 0.0596581 1.125 0.0596581L26.4375 10.1315C26.775 10.2404 27 10.5671 27 10.8937C27 11.2204 26.775 11.4926 26.4937 11.6015L1.125 21.9456C1.0125 22 0.9 22 0.7875 22C0.3375 21.9456 0 21.6189 0 21.1834C0 21.0745 -5.44824e-08 21.02 0.0562499 20.9111Z",
    fill: "#0296DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/sendButton.8b306ac2.svg";
export { ForwardRef as ReactComponent };